// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesBar_container__3K1Bg","link":"CategoriesBar_link__15uaz","isActive":"CategoriesBar_isActive__16lZv","mobileSpacer":"CategoriesBar_mobileSpacer__7wUaT"};